import { Checkbox, Box, CardContent, Typography, Grid } from "@mui/material";
import { useState, useEffect } from "react";
// import BreadCrumb from "../../../components/BreadCrumb";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import useStyles from "./styles";
import { Icon } from "@iconify/react";
import { FilterSelect } from "../../../components/Table/TableActions";
import { toast } from "react-toastify";
import nosearch from "../../../assets/images/no-search.svg";
import NotFounditem from "../../error/NotFound";
import { httprequest } from "../../../data/api";
import PageTitle from "../../../components/PageTitle";

const STUDENT_ATTENDANCE = "/api/v1/attendance/student";
const STUDENT_CLASS = "/api/v1/grade/classes";

const StudentAttendance = () => {
  const classes = useStyles();
  const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri"];
  // const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [studentAttendanceData, setStudentAttendanceData] = useState([]);
  const [classRecord, setClassRecord] = useState([]);
  const [currentStudentClass, setCurrentStudentClass] = useState({});
  const [terms, setTerms] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedTerm, setSelectedTerm] = useState("");

  /**
 * Fetches student attendance data based on the provided parameters.
 *
 * @param {Object} params - Parameters including class_id and term_id.
 */
  const getStudentAttendance = (params) => {
    httprequest.get(`${STUDENT_ATTENDANCE}`, { params }).then((res) => {
      setStudentAttendanceData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Fetches the list of student classes, sets the current class, terms, and fetches attendance.
 * Automatically selects the current class and its first term.
 */
  const getStudentClass = async () => {
    try {
      const res = await httprequest.get(`${STUDENT_CLASS}`);
      const classData = res?.data?.data;
      setClassRecord(classData);

      const currentClass = classData.find(clas => clas.is_current_class);
      setSelectedClass(currentClass?.class?.id);
      setTerms(currentClass?.terms);
      setCurrentStudentClass(currentClass);

      const params = {
        class_id: currentClass?.class?.id,
        term_id: currentClass?.terms?.[0]?.id
      };
      getStudentAttendance(params);
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Handles the change of selected class by the user.
 * Updates selected class, selected term, and fetches corresponding attendance data.
 *
 * @param {Event} event - React synthetic event.
 * @param {string} newClassId - ID of the newly selected class.
 */
  const handleClassChange = (event, newClassId) => {
    setSelectedClass(newClassId);
    const currentClass = classRecord.find(clas => clas.class.id === newClassId
    );
    const params = {
      class_id: currentClass?.class?.id,
      term_id: currentClass?.terms?.[0]?.id
    };
    getStudentAttendance(params);

    setTerms(currentClass?.terms);
    setSelectedTerm(currentClass?.terms?.[0]?.id);
  };

  /**
 * Automatically fetches attendance for the current class
 * when the list of class records is updated.
 *
 * @dependency classRecord
 */
  useEffect(() => {
    if (classRecord.length > 0) {
      const currentClass = classRecord.find(clas => clas.is_current_class);
      setCurrentStudentClass(currentClass);
      const params = {
        class_id: currentClass?.class?.id,
        term_id: currentClass?.terms?.[0]?.id
      };
      getStudentAttendance(params);
    }
  }, [classRecord]);

  /**
 * Sets the selected term based on the fetched student attendance data.
 *
 * @dependency studentAttendanceData.term.id
 */
  useEffect(() => {
    if (studentAttendanceData?.term?.id) {
      setSelectedTerm(studentAttendanceData?.term?.id);
    }
  }, [studentAttendanceData?.term?.id]);

  /**
 * Initializes the component by fetching student class and attendance data.
 *
 * @dependency []
 */
  useEffect(() => {
    getStudentAttendance();

    const fetchData = async () => {
      await getStudentClass();
    };
    fetchData();
  }, []);
  /**
 * Filters the student attendance data based on currently selected class and term.
 */
  const filteredAttendance = studentAttendanceData && studentAttendanceData?.class?.id === selectedClass && studentAttendanceData.term?.id === selectedTerm
    ? studentAttendanceData?.attendance
    : [];

  /**
 * Handles term selection change by user and fetches corresponding attendance data.
 *
 * @param {Event} event - React synthetic event from term select input.
 */
  const handleFilterByTerm = (event) => {
    const selectedTermValue = event.target.value;
    setSelectedTerm(selectedTermValue);
    const params = {
      class_id: currentStudentClass?.class?.id,
      term_id: selectedTermValue
    };
    getStudentAttendance(params);
  };

  /**
 * An array of class objects extracted from the classRecord.
 *
 * @type {Array<Object>}
 */
  const classesList = classRecord.map((data) => data.class);
  /**
 * An array of term options formatted from the selected class's terms.
 *
 * @type {Array<Object>}
 */
  const formattedTerms = terms?.map((item) => ({ name: item?.name, value: item?.id }));

  return (
    <>
      <div>
        <PageTitle
          title="Attendance"
          subtitle="View all my attendance"
        />
        {/* <BreadCrumb
          link_one="/class-activities/classes"
          link_one_name="My Class"
          active="Attendance"
          description="See the attendance details of my student."
        /> */}
      </div>
      <div className={`${classes.attcontent} page-content attend_css white_bg`}>
        <TabContext value={selectedClass}>
          {filteredAttendance.length > 0 && (
            <div className="flex align-items-center justify-content-between flex-wrap-items-600 margin-top-10-v600">
              <div className="tablist-container">
                <Tabs
                  className="overide-tablist"
                  onChange={handleClassChange}
                  aria-label="class tabs"
                >
                  {classesList.map((classInfo) => (
                    <Tab
                      key={classInfo.id}
                      value={classInfo.id}
                      label={classInfo.name}
                    />
                  ))}
                </Tabs>
              </div>
              <div className="tablist-container">
                <FilterSelect onChange={handleFilterByTerm}
                  optionsArray={formattedTerms} selectValue={selectedTerm} selectName={formattedTerms?.name}
                  selectIcon="ei:calendar"
                />
              </div>
            </div>
          )}
          {filteredAttendance.length > 0 && (
            <div>
              <div
                className={`${classes.legends} no_left`}
              >
                <div className={`${classes.systemkey}`}>
                  <div
                    className={`${classes.attlegend} flex gap-10 align-items-center flex-wrap-items-v430`}
                  >
                    <div className="flex gap-5 align-items-center">
                      <h6>Unselected</h6>
                      <Icon
                        icon="ci:checkbox-unchecked"
                        width="15"
                        height="15"
                        style={{ color: "#98A2B3" }}
                      />
                    </div>
                    <div className="flex gap-5 align-items-center">
                      <h6>No Record</h6>
                      <Icon
                        icon="bxs:checkbox-checked"
                        width="17"
                        height="17"
                        style={{ color: "#98A2B3" }}
                      />
                    </div>
                    <div className="flex gap-5 align-items-center">
                      <h6>Present</h6>
                      <Icon
                        icon="bxs:checkbox-checked"
                        width="17"
                        height="17"
                        style={{ color: "#3FAC64" }}
                      />
                    </div>
                    <div className="flex gap-5 align-items-center">
                      <h6>Absent</h6>
                      <Icon
                        icon="bxs:checkbox-checked"
                        width="17"
                        height="17"
                        style={{ color: "#D42620" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <TabPanel
            sx={{
              border: "1px solid #98A2B3",
              borderRadius: "8px",
              marginTop: "16px"
            }}
            className="scroll-x"
            value={selectedClass}
          >
            {filteredAttendance?.length === 0 ? (
              <div className={classes.notfound}>
                <NotFounditem
                  img={nosearch}
                  title="No Attendance Found"
                  subtitle="No attendance has been added."
                />
              </div>
            ) : (
              <Grid container spacing={2}>
                {filteredAttendance.map((week, weekIndex) => (
                  <Grid item lg={3} md={4} sm={6} xs={12} key={weekIndex}
                    variant="outlined"

                  >
                    <CardContent>
                      <Typography variant="h6" component="div" sx={{ background: "#F9FAFB", padding: "12px 0", fontWeight: "normal",
                        fontSize: "0.8rem" }}
                      >
          Week {week.week}
                      </Typography>
                      <div>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          {daysOfWeek.map((day, dayIndex) => (
                            <Typography key={dayIndex} variant="body2" component="div" sx={{ flex: 1, textAlign: "center", borderRight: dayIndex < daysOfWeek.length - 1 ? "1px solid #ccc" : "none", background: "#F9FAFB" }}>
                              {day.charAt(0)}
                            </Typography>
                          ))}
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          {daysOfWeek.map((day, dayIndex) => {
                            const dayRecord = week.record.find(record => record.day.toLowerCase() === day.toLowerCase());

                            return (
                              <Box key={`${weekIndex}-${dayIndex}`} sx={{ flex: 1, textAlign: "center", borderRight: dayIndex < daysOfWeek.length - 1 ? "1px solid #ccc" : "none" }}>
                                <Checkbox
                                  checked={dayRecord?.present === true || dayRecord?.present === false}
                                  sx={{
                                    color: dayRecord?.present === true ? "#3FAC64" : dayRecord?.present === false ? "#D42620" : "inherit",
                                    "&.Mui-checked": {
                                      color: dayRecord?.present === true ? "#3FAC64" : "#D42620"
                                    }
                                  }}
                                />
                              </Box>
                            );
                          })}
                        </Box>
                      </div>
                    </CardContent>
                  </Grid>
                ))}
              </Grid>
            )}
          </TabPanel>
        </TabContext>
        {/* <ToastContainer /> */}
      </div>
    </>
  );
};

export default StudentAttendance;
